import styled from 'styled-components'

const WalidacjaFailsStyle = styled.section`
  .high-headline-5 {
    margin: 16px 12px;
  }

  ul {
    list-style: none;
    padding: 0 12px;
  }
`
export default WalidacjaFailsStyle
